import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './shared/interceptors/http-request-interceptor';
import { HttpErrorInterceptor } from './shared/interceptors/http-error-interceptor';
import { TimeoutInterceptor,DEFAULT_TIMEOUT } from './shared/interceptors/timeout-interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Common Controls
import { SharedComponent } from './shared/shared.component';
import { LoginComponent } from './shared/login/login.component';
import { ForgotPasswordComponent } from './shared/forgot-password/forgot-password.component';
import { CheckboxModule } from 'primeng/checkbox';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { SidebarModule } from 'primeng/sidebar';
import { MessageService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CookieService } from 'ngx-cookie-service';
import { GoogleMapsModule } from '@angular/google-maps'

// Modules
import { AdminModule } from 'src/app/admin/admin.module';
import { AdminRoutingModule } from 'src/app/admin/admin-routing.module';
import { PatientModule } from 'src/app/patient/patient.module';
import { PatientRoutingModule } from 'src/app/patient/patient-routing.module';
import { TherapistModule } from 'src/app/therapist/therapist.module';
import { TherapistRoutingModule } from 'src/app/therapist/therapist-routing.module';
import { PipesModule } from './pipes/pipes/pipes.module';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    AppComponent,
    SharedComponent,
    LoginComponent,
    ForgotPasswordComponent,
    PageNotFoundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    SidebarModule,
    AdminModule, AdminRoutingModule,
    PatientModule, PatientRoutingModule,
    TherapistModule, TherapistRoutingModule,
    AccordionModule,
    AutoCompleteModule,
    ToastModule,
    PipesModule,
    GoogleMapsModule,
    PasswordModule
  ],
  exports: [
    CheckboxModule,
    SidebarModule,
    AccordionModule,
    AutoCompleteModule,
    TooltipModule,
    PasswordModule
  ],
  providers: [
    MessageService,
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
        theme: {
            preset: Aura
        }
    }),
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
    { provide: DEFAULT_TIMEOUT, useValue: 300000 }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


